export const parseIdArray = (arrayString: string | null) =>
  arrayString
    ?.split(',')
    .filter((id) => id.length > 0)
    .map((v) => parseInt(v)) ?? [];
